import React, { Component } from 'react'
import { memoizeWith } from 'ramda'
import { Tag, Input, Div, H6 } from '@driftt/tide-core'
import debounce from 'lodash.debounce'

const ENTITY_TYPES_TO_DISPLAY_TYPE = {
  'contact': 'attributes',
  'events': 'raw events',
  'playbookEvents': 'playbook events',
  'playbooks': 'playbooks',
  'tags': 'tags'
}

class List extends Component {
  constructor(props) {
    super(props)

    this.state = {
      query: ''
    }

    this.filterView = debounce(this._filterView, 200)
    this.getFilteredProperties = memoizeWith(this._getCurrentQuery, this._getFilteredProperties)
  }

  componentWillUnmount() {
    this.filterView.cancel();
  }

  handleSearchInputChange = (event) => {
    event.persist();
    this.filterView(event);
  }

  _getCurrentQuery = () => {
    return this.state.query;
  }

  _filterView = (queryEvent) => {
    const filterVal = queryEvent.target.value

    this.setState({
      query: filterVal
    })    
  }

  _getFilteredProperties = () => {
    const { displayKey, properties } = this.props
    const { query } = this.state

    const filterPredicate = prop => {
      return prop[displayKey].toLowerCase().includes(query.toLowerCase())
    };

    return properties.map(propertyGroup => ({
      ...propertyGroup,
      properties: propertyGroup.properties.filter(filterPredicate)
    }))
  }

  render() {
    const { displayKey, filterKey, onSelect, hideType = false, subEntityType } = this.props
    
    const filteredProperties = this.getFilteredProperties()

    return (
      <Div className="filter-builder-list">
        <Div className="filter-builder--search-attributes">
          <Input type="search" onChange={this.handleSearchInputChange} placeholder={`Search ${ENTITY_TYPES_TO_DISPLAY_TYPE[subEntityType]}`}/>
        </Div>
        <Div className="filter-builder-list--attributes">
          {filteredProperties.map(propertyGroup => {
            return (
              <Div key={propertyGroup.title}>
                <Div className="filter-builder-list--attribute-header">
                  <H6>{propertyGroup.title}</H6>
                </Div>
                <Div className="filter-builder-list--attributes-sub-list">
                  {
                    propertyGroup.properties.map(property => {
                      return (
                        <Div 
                          className="filter-builder-list--attributes--row" 
                          onClick={() => onSelect(property, subEntityType)} 
                          key={`filter-builder--${property[filterKey]}`}
                          title={property[displayKey]}
                        >
                          <Div className="filter-builder-list--attributes--name">
                            {property[displayKey]}
                          </Div>
                          {!hideType && <Tag size="small" className="filter-builder-list--attributes--type" text={property.type} />}
                        </Div>
                      )
                    })
                  }
                </Div>
              </Div>
            )
          })}
        </Div>
      </Div>
    )
  }
}

export default List
